import AsyncComponent from '../hoc/asyncComponent/asyncComponent';
import {Route, Switch } from 'react-router-dom';
import React from 'react';

// Components
import ResetPassword from '../containers/Auth/ResetPassword/SubmitOtp/SubmitOtp';
import Login from '../containers/Auth/Login/Login';

const asyncLogin = AsyncComponent(() => {
    return import('../containers/Auth/Login/Login')
});

const asyncLanding = AsyncComponent(() => {
    return import('../containers/Landing/landing')
});

const asyncCitizen = AsyncComponent(() => {
    return import('../containers/citizen/Citizen')
});
const asyncThnakyou = AsyncComponent(() => {
    return import('../containers/citizen/ThankPage')
});
const asyncNotFound =AsyncComponent(()=>{
    return import('../containers/Auth/NOTFoundPage/notfoundpage')
})
const PublicRoutes = ({ match }) => (
    <Switch>
        <Route path='/'                 exact component={asyncLanding}/>
        <Route path='/login'            exact component={asyncLogin} />
        <Route path='/citizen'            exact component={asyncCitizen} />
        <Route path='/success'            exact component={asyncThnakyou} />
        <Route path='/notFound'            exact component={asyncNotFound} />
        <Route path='/reset_password'   exact component={ResetPassword} />
	</Switch>
);

export default PublicRoutes;